/**
 * 404 Not Found Page
 * Displayed when user navigates to non-existent route
 */

import { Box, Typography, Button } from '@mui/material';
import { SearchOff as NotFoundIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_ROUTES } from '@/routes/routes';

/**
 * Not Found Page
 * User-friendly 404 error page
 */
export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 3,
        px: 2,
      }}
    >
      <NotFoundIcon sx={{ fontSize: 120, color: 'text.secondary' }} />

      <Typography variant="h3" component="h1" gutterBottom>
        404 - Page Not Found
      </Typography>

      <Typography variant="body1" color="text.secondary" textAlign="center">
        The page you're looking for doesn't exist or has been moved.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button variant="contained" onClick={() => navigate(PROTECTED_ROUTES.DASHBOARD)}>
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};
